import React from "react"
import { Outlet } from "react-router-dom"
import { SidemenuComponent } from "../Components/Admin/Sidemenu"

const AppLayout = () => {
  return (
    <div style={{ display: "flex" }}>
      <SidemenuComponent />
      <div style={{ flex: 1, overflow: "auto", padding: "20px" }}>
        <Outlet />
      </div>
    </div>
  )
}

export default AppLayout
